import React from 'react';

import Icon, { Props } from './icon';

export const ArrowUpIcon: React.FC<Props> = (props: Props) => {
  return (
    <Icon viewBox="0 0 36 36" {...props}>
      <path
        d="M31.5,24.6c-0.3,0-0.7-0.1-1-0.4L18,11.7L5.5,24.2c-0.5,0.5-1.4,0.5-1.9,0c-0.5-0.5-0.5-1.4,0-1.9L17,8.8
		c0.3-0.3,0.6-0.4,1-0.4c0,0,0,0,0,0c0.4,0,0.7,0.1,1,0.4l13.5,13.5c0.5,0.5,0.5,1.4,0,1.9C32.2,24.5,31.8,24.6,31.5,24.6z"
      />
    </Icon>
  );
};

export default ArrowUpIcon;
